export const debounce = (func, wait = 100) => {
    let timeout;

    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            func.apply(context, args);
        }, wait);
    }
}

export const templateDetails = () => {
    try {
        const templateName = document.querySelector('[data-template-name]').dataset.templateName
        const templateSuffix = document.querySelector('[data-template-suffix]').dataset.templateSuffix

        return [templateName, templateSuffix]
    } catch (error) {
        console.error(error)
    }
}
